import React from "react";
import Card from "../Card/Card";

const data = [
  {
    document: "Manual de Percepciones",
    year: '2026',
    //title: 'Manual',
    link: '/CAASIM/ManualPercepciones/Manual de Percepciones CAASIM 2026.pdf'
  },
  
];

function ManualPercepiones() {
  return (
    <div className="container py-4">
      <div className="secretaria_funciones">
        <h3 className="title text-uppercase">Manual de Percepciones</h3>
        <hr className="hr-gob" />
      </div>
      <div>
        <h4 className="title">Objetivo</h4>
        <p className="mb-4">El presente Manual de Percepciones para la Administración de la Comisión de Agua y Alcantarillado de Sistemas Intermunicipales, con el objeto de regular, establecer y coordinar los criterios administrativos aplicables para la integración, asignación, cálculo, control y pago de las remuneraciones, percepciones, prestaciones económicas y demás conceptos retributivos de las personas servidoras públicas de base sindicalizada y de confianza que presten sus servicios en el Organismo.</p>
      </div>
      <div className="row">
        {data.map((item, index) => (
          <Card
            key={index}
            document={item.document}
            title={item.title}
            href={item.link}
            year={item.year}
            type={"PDF"}
          />
        ))}
      </div>
    </div>
  );
}

export default ManualPercepiones;
